import React from 'react';

export default function TrxDetailHeader({ title }:{ title:string }){
  return (
    <div 
      style={{
        width: "100%",
        height: "2.5rem",
        paddingLeft: "0.75rem",
        paddingRight: "0.75rem",
        borderBottom: "1px solid #d1d5db",
        backgroundColor: "#e5e7eb",
        display: "flex",
        alignItems: "center"
      }}
>
      <h3 
        style={{
          fontSize: "1rem",
          fontWeight: "600",
          textTransform: "uppercase",
          lineHeight: "1.5rem",
          paddingBottom: "0.125rem",
          borderBottom: "4px solid #000000",
          color: "#000000"
        }}
      >
        {title}
      </h3>
    </div>
  )
}